import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getRegistrantsCatalog = state => state.models[name].registrants.results;
export const getCurRegistrant = state => state.models[name].registrant;